import { YDatabase } from '@databases/collab/y-database';
import { IntlShape } from 'react-intl-next';

import { initialDoc } from './migrations/initial-doc';
import { initialView } from './migrations/initial-view';
import { templateId } from './migrations/template-id';
import { transformViews } from './migrations/transform-views';

interface Migration {
  readonly version: number;

  apply(
    documentId: string,
    database: YDatabase,
    intlShape: IntlShape
  ): void | Promise<void>;
}

export class MigrationManager {
  private static readonly migrations: Migration[] = [
    initialDoc,
    templateId,
    initialView,
    transformViews,
  ];

  constructor(
    private readonly documentId: string,
    private readonly database: YDatabase,
    private readonly intlShape: IntlShape,
    private readonly remoteVersion: number
  ) {}

  async runPending() {
    for (const pendingMigration of this.pendingMigrations) {
      await pendingMigration.apply(this.documentId, this.database, this.intlShape);
    }
  }

  static getClientDocVersion(): number {
    const latestMigration = MigrationManager.migrations.reduce((prev, current) =>
      prev.version > current.version ? prev : current
    );

    return latestMigration.version;
  }

  private get pendingMigrations() {
    return MigrationManager.migrations.filter(
      (migration) => migration.version > this.remoteVersion
    );
  }
}
